module.exports = __webpack_public_path__ + "static/media/ic-live.92ddb324.svg";